export const Arrow = () => {
	return (
		<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.79289 14.364C8.40237 14.7545 8.40237 15.3877 8.79289 15.7782C9.18342 16.1687 9.81658 16.1687 10.2071 15.7782L15.5 10.4853L15.5 24.0711C15.5 24.6234 15.9477 25.0711 16.5 25.0711C17.0523 25.0711 17.5 24.6234 17.5 24.0711L17.5 10.3431L22.935 15.7782C23.3256 16.1687 23.9587 16.1687 24.3492 15.7782C24.7398 15.3876 24.7398 14.7545 24.3492 14.364L17.2782 7.29289C16.8877 6.90237 16.2545 6.90237 15.864 7.29289L8.79289 14.364Z"
				fill="#0E0E0E"
			/>
		</svg>
	);
};
